// extracted by mini-css-extract-plugin
export var arrows = "_n-6";
export var decrementer = "_n-a";
export var disabled = "_n-4";
export var error = "_n-1";
export var hiddenText = "_n-b";
export var incrementer = "_n-9";
export var input = "_n-8";
export var inputWrapper = "_n-0";
export var leadingIcon = "_n-c";
export var readonly = "_n-3";
export var regular = "_n-7";
export var small = "_n-5";
export var warning = "_n-2";